import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=591a8c35&scoped=true&"
import script from "./whole.vue?vue&type=script&lang=js&"
export * from "./whole.vue?vue&type=script&lang=js&"
import style0 from "./whole.vue?vue&type=style&index=0&id=591a8c35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a8c35",
  null
  
)

export default component.exports